import { useMemo } from 'react';
import { useQueryState } from '@ywwwtseng/react-kit';
import { type SelectToken } from '@/types';
import { displayAmount, getTokenPrice } from '@/utils/token';

export function useTokenPrice(tokenId?: string) {
  const tokens = useQueryState<SelectToken[]>('tokens');

  const value = useMemo(() => {
    return getTokenPrice(tokens ?? [], tokenId ?? '');
  }, [tokenId]);

  const formatted = useMemo(() => {
    return displayAmount(value);
  }, [value]);

  return {
    value,
    formatted,
  };
}
